import { useState, useRef, useEffect } from 'react';
import {View, ActivityIndicator, Platform, Dimensions, ScrollView} from 'react-native';
import styles from './style';
import * as FileSystem from 'expo-file-system';
import { api } from '../../api';
  
function WebViewComp({siteURL, url, navigation, screenName, isLogin = false, route, hideThis, bottomBarPages, loadingColor, isFocused = false, loadStripe = false, endFlowURLS = []}) {

    console.log("URL to view: ", url);
    const websiteURL = siteURL;
    const webViewRef = useRef(null);
    const webIframeRef = useRef(null);
    const [source, setSource] = useState("");

    const headerHide = hideThis.header !== '' ? `document.querySelectorAll('${hideThis.header}').forEach(div => { div.style.display = 'none' });` : '';
    const getHeaderHeight = hideThis.header !== '' ? `document.querySelectorAll('${hideThis.header}').forEach(div => { console.log(div); console.log(div.offsetHeight); window.parent.postMessage({ type: 'header', value: div.offsetHeight }, "*"); });` : '';
    const getFooterHeight = hideThis.footer !== '' ? `document.querySelectorAll('${hideThis.footer}').forEach(div => { console.log(div); console.log(div.offsetHeight); window.parent.postMessage({ type: 'footer', value: div.offsetHeight }, "*"); });` : '';
    const getBodyHeight = `document.querySelectorAll('body').forEach(div => { console.log(div); console.log(div.offsetHeight); window.parent.postMessage({ type: 'iframe', value: div.offsetHeight }, "*"); });`;
    const footerHide = hideThis.footer !== '' ? `document.querySelectorAll('${hideThis.footer}').forEach(div => { div.style.display = 'none' });`: '';

    let otherHide = '';
    if(hideThis.others.length > 0){
        for (let oh = 0; oh < hideThis.others.length; oh++) {
            const element = hideThis.others[oh];
            if(element !== ""){
                otherHide += `document.querySelectorAll('${element}').forEach(div => { div.style.display = 'none' });\n`;
            }
        }    
    }

    const hideElems = `(function() {
        ${headerHide}
        ${footerHide}
        ${otherHide}

        var css = 'body {-webkit-touch-callout: none; -webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none; -ms-user-select: none; user-select: none;}';
        var style = document.createElement('style');

        document.head.appendChild(style);
        style.type = 'text/css';
        if (style.styleSheet){
            // This is required for IE8 and below.
            style.styleSheet.cssText = css;
        } else {
            style.appendChild(document.createTextNode(css));
        }
        
    })();`

    const [INJECTED_JAVASCRIPT, UPDATEJAVA] = useState(isLogin ? `
    (function() {
        ${headerHide}
        ${footerHide}
        ${otherHide}

        var css = 'body {-webkit-touch-callout: none; -webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none; -ms-user-select: none; user-select: none;}';
        var style = document.createElement('style');

        document.head.appendChild(style);
        style.type = 'text/css';
        if (style.styleSheet){
            // This is required for IE8 and below.
            style.styleSheet.cssText = css;
        } else {
            style.appendChild(document.createTextNode(css));
        }

        let password = document.querySelectorAll("input[type='password']");
        password = password[0];
        password.addEventListener("keyup", function (event) {
            var unp = {
                "password":event.target.value
            };
            window.ReactNativeWebView.postMessage(JSON.stringify(unp));
        });

        let inputs = document.querySelectorAll("input");
        inputs.forEach(function(item){
            let name = item.getAttribute("name") ? item.getAttribute("name") : item.getAttribute("id");
            name = name.toLowerCase();
            if (name.indexOf("user") > -1 || name.indexOf("email") > -1) {
                item.addEventListener("keyup", function (event) {
                    var unp = {
                        "username":event.target.value
                    };
                    window.ReactNativeWebView.postMessage(JSON.stringify(unp));
                });
            }
        });
    })();` : hideElems);

    const [webViewLoading, setWebViewLoading] = useState(false);
    const [fadeLoad, setFadeLoad] = useState(true);

    useEffect(() => {
        // console.log("isFocused: ", isFocused);
        Platform.OS == "web" && (
            setTimeout(() => {
                setFadeLoad(false);
                addHideElems()
            }, 1000)
        )
    }, [isFocused])


    const [headerHeight, setHeaderHeight] = useState(0);
    const [footerHeight, setFooterHeight] = useState(0);
    const [iFrameHeight, setIframeHeight] = useState(0);
    const receiveMessage = (message) => {
        console.log("recieved message: ", message);
        if(message.data.type == "header"){
            setHeaderHeight(message.data.value);
        }
        
        if(message.data.type == "footer"){
            setFooterHeight(message.data.value);
        }

        if(message.data.type == "iframe"){
            setIframeHeight(message.data.value);
        }
    }

    const addHideElems = async () => {
        console.log("show this url: ", url);
        let iDoc = webIframeRef.current.contentDocument;
         try {
            const resp = await api(`v1/previewapp/config?url=${url}`, "GET", null)
            if(resp.status== 200){
                let data = resp.data;
                //   console.log(data);
                let html = data.result;
                html = html.replace('</body>', 
                    `<script type="text/javascript">
                        function hideElements(){
                            ${getHeaderHeight}
                            ${getFooterHeight}
                            ${getBodyHeight}
                        }
                        document.addEventListener("DOMContentLoaded", function() {
                            hideElements()
                        });
                        </script></body>
                `);
                html = html.replace("<!DOCTYPE html>", "");
                // console.log("iDoc ", iDoc);
                iDoc.open();
                iDoc.write(html);
                iDoc.close();
                window.addEventListener("message", (message) => receiveMessage(message), false);
            }
        } catch (error) {
            console.log("error: ", error);
            setSource({
                html: `
              <p style='text-align:center;'>
                Error getting webpage
              </p>`
            })
        }
    }

    if(Platform.OS == "web" && fadeLoad){
        return (
            <View style={styles.activityLoaderContainer}>
                <ActivityIndicator color={loadingColor} size={"large"} />
            </View>
        )
    }
   
    return (
        <View style={{ flex: 1, width: "100%"}}>
            {
                Platform.OS == "web" && (
                    <ScrollView contentContainerStyle={{width: Dimensions.get('window').width , height: iFrameHeight - headerHeight - footerHeight}}>
                        <iframe 
                            ref={webIframeRef} 
                            frameBorder="0" 
                            style={{overflow: "hidden", height: "100%", width:"100%", opacity: 0, zIndex: 1, position: 'absolute'}} 
                            height="100%" 
                            width="100%" 
                            id="contentiFrame"
                        />
                        {
                            headerHeight !== 0 && footerHeight !== 0 && (
                                <iframe 
                                    scrolling="no"
                                    src={url}
                                    frameBorder="0" 
                                    style={{overflow: "hidden", height: (iFrameHeight), width:"100%", zIndex: 2, marginTop: Number('-'+headerHeight)}} 
                                    height="100%" 
                                    width="100%" 
                                    id="contentiFrame2"
                                />
                            )
                        }
                    </ScrollView>
                )
            }
        </View>
    )
}
export default WebViewComp;